import React, { useEffect, useMemo, useState } from 'react'

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AlertByStatusPiechart from './Charts/Consolidated/AlertByStatusPiechart';
import AlertByTypeBarchart from './Charts/Consolidated/AlertByTypeBarchart';
import AlertBySeverityDonutChart from './Charts/Consolidated/AlertBySeverityDonutChart';
import AlertByTimeTrendChart from './Charts/Consolidated/AlertByTimeTrendChart';
import AlertByTimeBarchart from './Charts/Consolidated/AlertByTimeBarchart';
import AlertBySystemPiechart from './Charts/Consolidated/AlertBySystemPiechart';
import DeviceStatusStackedBarChart from './Charts/Consolidated/DeviceStatusStackedBarChart';

import BusinessIcon from '@mui/icons-material/Business';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import VideoCameraBackIcon from '@mui/icons-material/VideoCameraBack';

import "react-resizable/css/styles.css";
import GridLayout from "react-grid-layout";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";

import { MULTI_TIME_ZONE } from '../../config';
import { GetTodaysAlertCount, GetSiteCount, GetUserCountStatus, GetSystemHealth, GetDashbordAlertStatus } from '../../services/dashboardService';
import { multiTimeZoneHelper, ConvertDate } from '../../utils/utils';
import MainCCTV from './Charts/CCTV/MainCCTV';
import MainIDS from './Charts/IDS/MainIDS';
import DashboardTodaysStatus from './DashboardTodaysAlertStatus';
import DashboardTodaysAlertStatus from './DashboardTodaysAlertStatus';
import AlertTemplateMessage from '../Configuration/AlertTemplate/AlertTemplateMessage';
import DashboardTodaysSeverityDetails from './DashboardTodaysSeverityDetails';


const AccordionMunu = ({isDarkTheme , SiteName, handleModalShow, siteId, getcsvFileName, deviceStatus, alertsData}) => {
    const [expanded, setExpanded] = useState(false);
    const [loggedInUser, setLoggedInUser] = useState(null);
    const [open, setOpen] = useState(false);
    const[todaysAlertCount,setTodaysAlertCount] = useState(0)
    const[closedAlertCount,setClosedAlertCount] = useState(0)
    const [siteCount,setSiteCount] = useState(0)
    const [userCount,setUserCount] = useState(0)
    const [systemHealthDevicesOfflineCount, setSystemHealthDevicesOfflineCount] = useState(0);
    const [systemHealthDevicesOnlineCount, setSystemHealthDevicesOnlineCount] = useState(0);
    const [onlinePercent, setOnlinePercent] = useState(0);
    const[count, setCount] = useState(0)
    const [nonIntegratedDevicesCount, setNonIntegratedDevicesCount] = useState(0);
    const [alertCounts, setAlertCounts] = useState(0);

    const ResponsiveGridLayout = WidthProvider(Responsive);
    
    const getFirstDate = () => {
        let d;
        let loggedInUser = JSON.parse(localStorage.getItem('user'))
        if (MULTI_TIME_ZONE) {
          d = multiTimeZoneHelper(loggedInUser?.OffsetMinutes)
        } else {
          d = new Date();
        }
        return d;
      }
      
      const getSecondDate = () => {
        let e;
        let loggedInUser = JSON.parse(localStorage.getItem('user'))
        if (MULTI_TIME_ZONE) {
          e = multiTimeZoneHelper(loggedInUser?.OffsetMinutes)
        } else {
          e = new Date();
        }
        return e;
      }
    

    useEffect(()=>{
        let user = JSON.parse(localStorage.getItem('user'))
        let start = getFirstDate();
        let end = getSecondDate();
        let startDate = ConvertDate(new Date(start.setHours(0, 0, 0, 0)));
        let endCurrDate = ConvertDate(end);
        getTodaysAlertCount(user?.Id,startDate,endCurrDate)
    },[])

    useEffect(()=>{
        let user = JSON.parse(localStorage.getItem('user'))
        getSiteCount(user?.Id)
        getUserCount(user?.Id)
    },[])


    useEffect(() => {
        let tempUser = JSON.parse(localStorage.getItem('user'))
        if (tempUser) {
            let start = getFirstDate();
            let end = getSecondDate();
            let startDate = ConvertDate(new Date(start.setHours(0, 0, 0, 0)));
            let endCurrDate = ConvertDate(end);
            getTodaysAlertCount(tempUser?.Id,startDate,endCurrDate);           
        }
    }, [loggedInUser])

    useEffect(() => {
        let tempUser = JSON.parse(localStorage.getItem('user'))
        if (tempUser) {
           SystemHealthCount()
        }
    }, [localStorage.getItem('user')]);

    const getTodaysAlertCount = (userID,startDate,endCurrDate) =>{
        let user = JSON.parse(localStorage.getItem('user'))
        GetTodaysAlertCount(user?.Id,startDate,endCurrDate).then((resp)=>{
            if (resp.Status == "success"){
                if(resp.Data != null){
                    if (resp.Data) {
                        const totalAlertCount = resp.Data.reduce((sum, item) => sum + (item.AlertCount || 0), 0);
                        setTodaysAlertCount(totalAlertCount);
                        let closedCount = resp.Data.find((item)=> item.AlertStatus == "Closed");
                        setClosedAlertCount(closedCount?.AlertCount || 0)

                        
                    } else {
                        setTodaysAlertCount(0);
                    }
                    //setTodaysAlertCount(resp.Data[0].AlertCount)
                }
            }else {
                setTodaysAlertCount(0)
            }
        })
    }

    const getSiteCount = () =>{
        let user = JSON.parse(localStorage.getItem('user'))
        GetSiteCount(user?.Id).then((resp)=>{
            if (resp.Status == "success"){
                if(resp.Data != null){
                    setSiteCount(resp.Data[0].SiteCount)
                }
            }else {
                setSiteCount(0)
            }
        }).catch(err => console.log(err))
    }

    const getUserCount = () =>{
        let user = JSON.parse(localStorage.getItem('user'))
        GetUserCountStatus(user?.Id).then((resp)=>{
            if (resp.Status == "success"){
                if(resp.Data != null){
                    setUserCount(resp.Data.userCount)
                }
            }else {
                setUserCount(0)
            }
        }).catch(err => console.log(err))
    }


    const getDashboardAlertStatus = (userID,startDate,endCurrDate,widgetId) =>{
        // let user = JSON.parse(localStorage.getItem('user'));
        // // GetDashbordAlertStatus(userId,startDate,endCurrDate,widgetId)
        // GetDashbordAlertStatus(user?.Id,startDate,endCurrDate,widgetId)
        // .then((resp)=>{
        //     if(resp.Status == "success"){
        //         console.log("Result---", resp);
                
        //         // if(resp.Data != null){
        //         //     setAlertCounts(resp.Data)
        //         // }
        //         // else{
        //         //     setAlertCounts(0)
        //         // }
        //     }
        // })
        // .catch(err => console.log(err))
    }

    const SystemHealthCount = () => {
        let user = JSON.parse(localStorage.getItem('user'))
        try{
            GetSystemHealth(user?.Id).then((resp) => {
                if (resp.Status == "success") {
                    if(resp.Data == null){
                        return  
                    }
                    let totalSystemHealthOffline = resp.Data.filter(item =>  item.DeviceStatus == "0")
                    setSystemHealthDevicesOfflineCount(totalSystemHealthOffline[0]?.StatusCount || 0)
                    let offlineCount = totalSystemHealthOffline[0]?.StatusCount || 0;
                    let totalSystemHealthOnline = resp.Data.filter(item => item.DeviceStatus == "1")
                    setSystemHealthDevicesOnlineCount(totalSystemHealthOnline[0]?.StatusCount || 0)
                    let onlineCount = totalSystemHealthOnline[0]?.StatusCount || 0
                    let total = parseInt(onlineCount) + parseInt(offlineCount)
                    let percent = (onlineCount / total) * 100;
                    if (isNaN(percent)) {
                        setOnlinePercent(0);
                    } else {
                        setOnlinePercent(percent.toFixed(0));
                    }

                    let c = count + 1;
                    setCount(c)

                    let nonIntegratedDevices = resp.Data.filter(item => item.DeviceStatus == "-1");
                    setNonIntegratedDevicesCount((nonIntegratedDevices[0]?.StatusCount || 0));
                } 

            })
        }catch(error){
            console.error(error)
        }
    }

    function getFromToTime(timeframe, label) {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        let FromDateTime = "";
        let ToDateTime = "";

        if (timeframe === "Hourly") {
            const hour = String(label).padStart(2, '0');
            FromDateTime = `${yyyy}-${mm}-${dd} ${hour}:00:00`;
            ToDateTime = `${yyyy}-${mm}-${dd} ${hour}:59:59`;
        } else if (timeframe === "Daily") {
            // label is day name (e.g. "Monday")
            const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            const targetDay = daysOfWeek.indexOf(label);
            const currentDay = today.getDay();
            let diff = currentDay - targetDay;
            if (diff < 0) diff += 7;
            const targetDate = new Date(today);
            targetDate.setDate(today.getDate() - diff);
            const tyyyy = targetDate.getFullYear();
            const tmm = String(targetDate.getMonth() + 1).padStart(2, '0');
            const tdd = String(targetDate.getDate()).padStart(2, '0');
            FromDateTime = `${tyyyy}-${tmm}-${tdd} 00:00:00`;
            ToDateTime = `${tyyyy}-${tmm}-${tdd} 23:59:59`;
        } else if (timeframe === "Weekly") {
            // label is like "09 Jun - 15 Jun"
            const match = label.match(/^(\d{2}) (\w{3}) - (\d{2}) (\w{3})$/);
            if (match) {
                const [ , startDay, startMon, endDay, endMon ] = match;
                const startDate = new Date(`${startDay} ${startMon} ${yyyy}`);
                const endDate = new Date(`${endDay} ${endMon} ${yyyy}`);
                const wsYYYY = startDate.getFullYear();
                const wsMM = String(startDate.getMonth() + 1).padStart(2, '0');
                const wsDD = String(startDate.getDate()).padStart(2, '0');
                const weYYYY = endDate.getFullYear();
                const weMM = String(endDate.getMonth() + 1).padStart(2, '0');
                const weDD = String(endDate.getDate()).padStart(2, '0');
                FromDateTime = `${wsYYYY}-${wsMM}-${wsDD} 00:00:00`;
                ToDateTime = `${weYYYY}-${weMM}-${weDD} 23:59:59`;
            }
        } else if (timeframe === "Monthly") {
            // label is month name (e.g. "June")
            const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
            ];
            const monthIdx = monthNames.indexOf(label);
            if (monthIdx !== -1) {
            const firstDay = new Date(yyyy, monthIdx, 1);
            const lastDay = new Date(yyyy, monthIdx + 1, 0);
            const fYYYY = firstDay.getFullYear();
            const fMM = String(firstDay.getMonth() + 1).padStart(2, '0');
            const fDD = String(firstDay.getDate()).padStart(2, '0');
            const lYYYY = lastDay.getFullYear();
            const lMM = String(lastDay.getMonth() + 1).padStart(2, '0');
            const lDD = String(lastDay.getDate()).padStart(2, '0');
            FromDateTime = `${fYYYY}-${fMM}-${fDD} 00:00:00`;
            ToDateTime = `${lYYYY}-${lMM}-${lDD} 23:59:59`;
            }
        }
        return { FromDateTime, ToDateTime };
    }


    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <>
            <Accordion expanded={true} className='DashboardAccordion'  style={{display:"none"}}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    {/* <Typography component="span" className='HeaderNameTitle'>Consolidated</Typography> */}
                    <Typography component="span" className='HeaderNameTitle'>Site Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                        <DashboardTodaysAlertStatus 
                         SiteName={SiteName}
                         handleModalShow={handleModalShow}
                         siteId={siteId}
                         getcsvFileName={getcsvFileName}
                         deviceStatus={deviceStatus}
                         alertsData={alertsData}/>

                        <h5>Last 30 Days</h5>
                        
                        <hr/>

                        <div className='GridChartsLayoutDiv'>
                                <>
                                    <div key="a" className='systemHealth widthChartsDiv m-2'>
                                        <div className='ChartHeader drag-handle'>
                                            <p>Alert Count By Status</p>
                                        </div>
                                        <AlertByStatusPiechart isDarkTheme={isDarkTheme} SiteName={SiteName} handleModalShow={handleModalShow} siteId={siteId} getcsvFileName={getcsvFileName} alertsData={alertsData}/>
                                    </div>

                                    <div key="b" className='systemHealth widthChartsDiv m-2'>
                                        <div className='ChartHeader drag-handle'>
                                            <p>Alert Count By Type</p>
                                        </div>
                                        <AlertByTypeBarchart isDarkTheme={isDarkTheme} SiteName={SiteName} handleModalShow={handleModalShow} siteId={siteId} getcsvFileName={getcsvFileName} alertsData={alertsData}/>
                                    </div>

                                    <div key="c" className='systemHealth widthChartsDiv m-2'>
                                        <div className='ChartHeader drag-handle'>
                                            <p>Alert Count By Severity</p>
                                        </div>
                                        <AlertBySeverityDonutChart isDarkTheme={isDarkTheme} SiteName={SiteName} handleModalShow={handleModalShow} siteId={siteId} getcsvFileName={getcsvFileName} alertsData={alertsData}/>
                                    </div>

                                    <div key="d" className='systemHealth widthChartsDiv m-2'>
                                        <div className='ChartHeader drag-handle'>
                                            <p>Alert Count By Time</p>
                                        </div>
                                        <AlertByTimeBarchart isDarkTheme={isDarkTheme} SiteName={SiteName} siteId={siteId} handleModalShow={handleModalShow} getFromToTime={getFromToTime} getcsvFileName={getcsvFileName}/>
                                    </div>

                                    <div key="e" className='systemHealth widthChartsDiv m-2'>
                                        <div className='ChartHeader drag-handle'>
                                            <p>Alert Count By Time</p>
                                        </div>
                                        <AlertByTimeTrendChart isDarkTheme={isDarkTheme} SiteName={SiteName} siteId={siteId} handleModalShow={handleModalShow} getFromToTime={getFromToTime} getcsvFileName={getcsvFileName}/>
                                    </div>

                                    <div key="f" className='systemHealth widthChartsDiv m-2'>
                                        <div className='ChartHeader drag-handle'>
                                            <p>Alert Count By System</p>
                                        </div>
                                        <AlertBySystemPiechart isDarkTheme={isDarkTheme} SiteName={SiteName} siteId={siteId} handleModalShow={handleModalShow} getcsvFileName={getcsvFileName} alertsData={alertsData}/>
                                    </div>
                                </>
                                    <>
                                     <div key="g" className='systemHealth widthChartsDiv m-2'>
                                        <div className='ChartHeader drag-handle'>
                                            <p>Device Status By Systems</p>
                                        </div>
                                        <DeviceStatusStackedBarChart SiteName={SiteName} siteId={siteId} handleModalShow={handleModalShow} getcsvFileName={getcsvFileName} deviceStatus={deviceStatus}/>
                                    </div>
                                    </>
                        </div>

                        {/* </GridLayout> */}
                </AccordionDetails>
            </Accordion>    

            <div className='MainDashboardAccordionDiv'>
                <DashboardTodaysSeverityDetails
                    SiteName={SiteName}
                    handleModalShow={handleModalShow}
                    siteId={siteId}
                    getcsvFileName={getcsvFileName}
                    deviceStatus={deviceStatus}
                    alertsData={alertsData} />

                    <div className='GridChartsLayoutDiv mt-3'>
                                <>
                                    <div key="a" className='systemHealth widthChartsDiv m-2'>
                                        <div className='ChartHeader drag-handle'>
                                            <p>Alert Count By Status - 30 Days</p>
                                        </div>
                                        <AlertByStatusPiechart isDarkTheme={isDarkTheme} SiteName={SiteName} handleModalShow={handleModalShow} siteId={siteId} getcsvFileName={getcsvFileName} alertsData={alertsData}/>
                                    </div>

                                    <div key="b" className='systemHealth widthChartsDiv m-2'>
                                        <div className='ChartHeader drag-handle'>
                                            <p>Alert Count By Type - 30 Days</p>
                                        </div>
                                        <AlertByTypeBarchart isDarkTheme={isDarkTheme} SiteName={SiteName} handleModalShow={handleModalShow} siteId={siteId} getcsvFileName={getcsvFileName} alertsData={alertsData}/>
                                    </div>

                                    <div key="c" className='systemHealth widthChartsDiv m-2'>
                                        <div className='ChartHeader drag-handle'>
                                            <p>Alert Count By Severity - 30 Days</p>
                                        </div>
                                        <AlertBySeverityDonutChart isDarkTheme={isDarkTheme} SiteName={SiteName} handleModalShow={handleModalShow} siteId={siteId} getcsvFileName={getcsvFileName} alertsData={alertsData}/>
                                    </div>

                                    <div key="d" className='systemHealth widthChartsDiv m-2'>
                                        <div className='ChartHeader drag-handle'>
                                            <p>Alert Count By Time - 30 Days</p>
                                        </div>
                                        <AlertByTimeBarchart isDarkTheme={isDarkTheme} SiteName={SiteName} siteId={siteId} handleModalShow={handleModalShow} getFromToTime={getFromToTime} getcsvFileName={getcsvFileName}/>
                                    </div>

                                    <div key="e" className='systemHealth widthChartsDiv m-2'>
                                        <div className='ChartHeader drag-handle'>
                                            <p>Alert Count By Time - 30 Days</p>
                                        </div>
                                        <AlertByTimeTrendChart isDarkTheme={isDarkTheme} SiteName={SiteName} siteId={siteId} handleModalShow={handleModalShow} getFromToTime={getFromToTime} getcsvFileName={getcsvFileName}/>
                                    </div>

                                    <div key="f" className='systemHealth widthChartsDiv m-2'>
                                        <div className='ChartHeader drag-handle'>
                                            <p>Alert Count By System - 30 Days</p>
                                        </div>
                                        <AlertBySystemPiechart isDarkTheme={isDarkTheme} SiteName={SiteName} siteId={siteId} handleModalShow={handleModalShow} getcsvFileName={getcsvFileName} alertsData={alertsData}/>
                                    </div>

                                     <div key="g" className='systemHealth widthChartsDiv m-2'>
                                        <div className='ChartHeader drag-handle'>
                                            <p>Device Status By Systems - 30 Days</p>
                                        </div>
                                        <DeviceStatusStackedBarChart SiteName={SiteName} siteId={siteId} handleModalShow={handleModalShow} getcsvFileName={getcsvFileName} deviceStatus={deviceStatus}/>
                                    </div>
                                </>
                        </div>
            </div>       
        </>
    )
}

export default AccordionMunu